var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"block text-align-center"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("抱歉，您访问的页面不存在或已被移除")]),_c('p',[_vm._v("The page you are looking for does not exist. Please check the URL or return to the homepage.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }